import { RouteEnum } from '@/models/route/Route.model.ts';

export type RouteDescriptionsTranslation = Partial<Record<RouteEnum, string>>;

export const routeDescriptionsTranslation: RouteDescriptionsTranslation = {
  [RouteEnum.COMMISSION_CONFIGURATION]: 'Zarządzaj stawkami prowizji dla wybranego zakresu.',
  [RouteEnum.COMMISSIONS]: 'Monitoruj potencjalne i zatwierdzone prowizje.',
  [RouteEnum.CONTACTS]: 'Przeglądaj osoby i zarządzaj relacjami z klientami.',
  [RouteEnum.CUSTOMERS]: 'Przeglądaj i porządkuj bazę klientów.',
  [RouteEnum.DASHBOARD]: 'Najważniejsze informacje i szybkie działania.',
  [RouteEnum.DICTIONARIES]: 'Zarządzaj wartościami wykorzystywanymi w formularzach i ofertach.',
  [RouteEnum.FAILED_WORKFLOW_ACTIONS]: 'Sprawdzaj błędne akcje workflow i uruchamiaj je ponownie.',
  [RouteEnum.OFFER_DEFINITIONS]: 'Twórz i utrzymuj definicje ofert używane w procesach.',
  [RouteEnum.PROCESSES]: 'Zarządzaj procesami i monitoruj ich realizację.',
  [RouteEnum.RECURRING_RESERVATIONS]:
    'Zarządzaj cyklicznym najmem zasobów i wystąpieniami do przełożenia.',
  [RouteEnum.RESOURCE_CALENDAR]: 'Planuj i monitoruj rezerwacje zasobów.',
  [RouteEnum.ROLES]: 'Twórz role, ustalaj ich poziom w hierarchii i kompletuj uprawnienia.',
  [RouteEnum.SUPERVISORS]: 'Zarządzaj opiekunami i ich dostępem do klientów.',
  [RouteEnum.TASKS]: 'Planuj i porządkuj zadania zespołu.',
  [RouteEnum.USERS]: 'Zarządzaj kontami użytkowników i ich rolami.',
};
